import {
  loadAndMigrateState,
  Migrator,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 1,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 2,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 3,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 4,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateGegeState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
